import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';

import { useGlobals } from '@shared/contexts/GlobalsContext';
import EVENTS from '../../constants/event-bus-events';
import MicroApp from '../../components/MicroApp';
import useMicroServicesTools from '../../hooks/use-micro-services-tools';
import useMerchantSettings from '../../hooks/use-merchant-settings';
import createQueryConfig from '../../queries';

const containerStyle = {
  display: 'flex',
  height: '100%',
  flex: 1,
};

const loadingContainerStyle = {
  ...containerStyle,
  justifyContent: 'center',
  alignItems: 'center',
};

const contractStyle = {
  flex: 1,
};

function Loading() {
  return (
    <div style={loadingContainerStyle}>
      <Spin />
    </div>
  );
}

export function SettingsApp() {
  const location = useLocation();
  const { eventBus, queryClient, apiClient } = useGlobals();
  const fullPath = `${location.pathname}${location.search}`;
  const microServicesTools = useMicroServicesTools('settings');
  const { isLoading: isLoadingSettings, merchantSettings } =
    useMerchantSettings();
  const queryConfig = createQueryConfig(queryClient, apiClient);
  const { status: subscriptionQueryStatus } = useQuery(
    queryConfig.subscription(merchantSettings)
  );
  const hasChargebeeSubscription = subscriptionQueryStatus === 'success';

  useEffect(() => {
    eventBus.emit(EVENTS.DISABLE_SPINNER);
    eventBus.emit(EVENTS.CLOSE_MENU);

    return () => {
      eventBus.emit(EVENTS.ENABLE_SPINNER);
    };
  }, []);

  if (isLoadingSettings || subscriptionQueryStatus === 'pending') {
    return <Loading />;
  }

  return (
    <div style={containerStyle}>
      <MicroApp
        name="settings"
        style={contractStyle}
        loading={<Loading />}
        settings={merchantSettings}
        mountPath="/settings"
        pathAndQuery={fullPath}
        useHashHistory={false}
        hasChargebeeSubscription={hasChargebeeSubscription}
        {...microServicesTools}
      />
    </div>
  );
}
